<template>
    <div>
        <div class="container-md ">
            <div class=" container-bg p-4">
                <div class="row">
                    <div class="col-12">
                        <h3 class="text-uppercase">Committees Documents</h3>
                    </div>

                </div>
                <div class="row mt-4">
                    <div class="col-md-11 col-12">
                        <div class="float-right">
                            <input class="search-box" type="text" placeholder="Zoeken">
                            <button class="search-btn" ><img
                                    src="/assets/img/search.svg" alt="Search"
                                    style="margin-bottom: 4px"></button>
                        </div>
                    </div>
                    <div class="col-md-1" style="margin-left: -21px;margin-top: 5px;">
                        <i class="fa fa-plus float-right mt-1" data-toggle="modal" data-target="#newItemgroup"
                           style="font-size: 24px;cursor: pointer"></i>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-lg-6">
                        <div class="form-group" style=" margin-left: 85px;">
                            <select class="form-control" id="exampleFormControlSelect1" style="background-color: #292929; color: white;">
                                <option>Folder Name</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="form-group" style=" margin-right: 25px;">
                            <select class="form-control" id="exampleFormControlSelect1" style="background-color: #292929; color: white;">
                                <option>Modif. Date</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="form-group" style="margin-right: 69px; margin-left: -30px;">
                            <select class="form-control" id="exampleFormControlSelect1" style="background-color: #292929; color: white;">
                                <option>Doc. number</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="flex-container flex-body mt-3" data-toggle="collapse" data-target="#next">
                    <div class="item text-center" style="flex: 2.2">
                        <img    src="/assets/img/Folder.svg"
                                alt=""
                        >
                    </div>
                    <div class="item text-white" style="flex: 7.2">Folder name lorem ipsum</div>
                    <div class="item text-white" style="flex: 2.1">12/04/2020</div>
                    <div class="item text-white text-center">Muzikanten</div>

                    <div class="item text-white" style="flex: 2">
                        <a class="text-white" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#deleteModal"></i></a>
                        <a class="text-white" style="margin-right:10px"><i class="fa fa-plus" aria-hidden="true" data-toggle="modal" data-target="#addfileModal"></i></a>
                        <a class="text-white"><i class="fa fa-pencil"></i></a>
                    </div>
                </div>
                <div id="next" class="collapse" style="margin-top: 18px; width: 92%; margin-left: 35px;">
                    <div class="row" style="background-color: white; height: 80px;padding-top: 25px; padding-left: 40px;">

                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-2">
                                    <img src="/assets/img/Docicon.svg" alt="" >
                                </div>
                                <div class="col-lg-6">
                                    <span>Document title lorem</span>
                                </div>
                                <div class="col-lg-4">
                                    <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#deleteModal"></i></a>
                                    <a class=""><i class="fa fa-pencil"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-2">
                                    <img src="/assets/img/Docicon.svg" alt="" >
                                </div>
                                <div class="col-lg-6">
                                    <span>Document title lorem</span>
                                </div>
                                <div class="col-lg-4">
                                    <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#deleteModal"></i></a>
                                    <a class=""><i class="fa fa-pencil"></i></a>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="row" style="background-color: white; height: 80px; padding-top: 25px; padding-left: 40px;">

                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-2">
                                    <img src="/assets/img/Docicon.svg" alt="" >
                                </div>
                                <div class="col-lg-6">
                                    <span>Document title lorem</span>
                                </div>
                                <div class="col-lg-4">
                                    <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#"></i></a>
                                    <a class=""><i class="fa fa-pencil"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-2">
                                    <img src="/assets/img/Docicon.svg" alt="" >
                                </div>
                                <div class="col-lg-6">
                                    <span>Document title lorem</span>
                                </div>
                                <div class="col-lg-4">
                                    <a class="" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#"></i></a>
                                    <a class=""><i class="fa fa-pencil"></i></a>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div class="flex-container flex-body mt-4">
                    <div class="item text-center" style="flex: 2.2">
                        <img    src="/assets/img/Folder.svg"
                                alt=""
                        >
                    </div>
                    <div class="item text-white" style="flex: 7.2">Folder name lorem ipsum</div>
                    <div class="item text-white" style="flex: 2.1">12/04/2020</div>
                    <div class="item text-white text-center" style="">Muzikanten</div>

                    <div class="item text-white" style="flex: 2">
                        <a class="text-white" style="margin-right:10px"><i class="fa fa-trash" aria-hidden="true" data-toggle="modal" data-target="#deleteModal"></i></a>
                        <a class="text-white" style="margin-right:10px"><i class="fa fa-plus" aria-hidden="true" data-toggle="modal" data-target="#addfileModal"></i></a>
                        <a class="text-white"><i class="fa fa-pencil"></i></a>
                    </div>
                </div>
            </div>
        </div>

        <!--        document modal-->
        <div class="modal fade" id="newItemgroup" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
             aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom: unset">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">

                            <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <h5 class="text-uppercase">add new files</h5>
                                    </div>


                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Create new folder for your file/s:</label>
                                            <div class="row ml-3 mt-2">
                                                <label for="name" style="margin-top: 5px;">Folder name</label>
                                                <div class="col-lg-6"><input type="text" class="form-control" id=""
                                                                             style="width: 300px"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Or select an existing folder for your file/s:</label>
                                            <div class="row ml-3 mt-2">

                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Folder name
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Folder name
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row ml-3 mt-3">

                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Lorem ipsum
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Lorem ipsum
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row ml-3 mt-3">

                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Dolorumset Qutern
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Dolorumset Qutern
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="name">Attach file/s:</label>
                                            <div class="row">
                                                <div class="col-lg-1">
                                                    <img src="/assets/img/attach_blue.svg"
                                                         alt="">
                                                </div>
                                                <div class="col-lg-7">
                                                    <label style="color: #4192D9">Main Song: Dolor setsum lorem</label>
                                                </div>
                                                <div class="col-lg-3">
                                                    <i class="fa fa-trash" style="color: #4192D9; margin-left:250px;"
                                                       aria-hidden="true"></i>
                                                </div>

                                            </div>
                                            <div class="row">
                                                <div class="col-lg-1">
                                                    <img src="/assets/img/attach_blue.svg"
                                                         alt="">
                                                </div>
                                                <div class="col-lg-7">
                                                    <label style="color: #4192D9">Main Song: Dolor setsum lorem</label>
                                                </div>
                                                <div class="col-lg-3">
                                                    <i class="fa fa-trash" style="color: #4192D9; margin-left:250px;"
                                                       aria-hidden="true"></i>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-10">
                                        <div class="form-group">

                                            <input type="text" class="form-control" id="name" value="Text input name">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <button class="btn btn-dark"><img src="/assets/img/attach_blue.svg"
                                                                          alt=""></button>
                                    </div>

                                    <i class="fa fa-plus float-left "
                                       style="font-size: 24px;cursor: pointer; margin-left: 14px; margin-top: 8px;"></i>


                                </div>
                            </div>


                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <button class="btn-dark float-right mt-5">Done</button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
        <!--         delete modal-->
        <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
             aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom: unset">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <p class="text-center">Are you sure you want to delete it? This will affect all members related.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 text-center mt-4 mb-5">
                                <button class="btn-dark">Yes, delete</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!--        add file modal-->
        <div class="modal fade" id="addfileModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
             aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom: unset">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">

                            <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <h5 class="text-uppercase">add new files</h5>
                                    </div>


                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Create new folder for your file/s:</label>
                                            <div class="row ml-3 mt-2">
                                                <label for="name" style="margin-top: 5px;">Folder name</label>
                                                <div class="col-lg-6"><input type="text" class="form-control" id=""
                                                                             style="width: 300px"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Or select an existing folder for your file/s:</label>
                                            <div class="row ml-3 mt-2">

                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Folder name
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Folder name
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row ml-3 mt-3">

                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Lorem ipsum
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Lorem ipsum
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row ml-3 mt-3">

                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Dolorumset Qutern
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="form-check  ">
                                                        <input class="form-check-input" type="checkbox" value=""
                                                               id="defaultCheck1">
                                                        <label class="form-check-label" for="defaultCheck1">
                                                            Dolorumset Qutern
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="name">Attach file/s:</label>
                                            <div class="row">
                                                <div class="col-lg-1">
                                                    <img src="/assets/img/attach_blue.svg"
                                                         alt="">
                                                </div>
                                                <div class="col-lg-7">
                                                    <label style="color: #4192D9">Main Song: Dolor setsum lorem</label>
                                                </div>
                                                <div class="col-lg-3">
                                                    <i class="fa fa-trash" style="color: #4192D9; margin-left:250px;"
                                                       aria-hidden="true"></i>
                                                </div>

                                            </div>
                                            <div class="row">
                                                <div class="col-lg-1">
                                                    <img src="/assets/img/attach_blue.svg"
                                                         alt="">
                                                </div>
                                                <div class="col-lg-7">
                                                    <label style="color: #4192D9">Main Song: Dolor setsum lorem</label>
                                                </div>
                                                <div class="col-lg-3">
                                                    <i class="fa fa-trash" style="color: #4192D9; margin-left:250px;"
                                                       aria-hidden="true"></i>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-10">
                                        <div class="form-group">

                                            <input type="text" class="form-control" id="name" value="Text input name">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <button class="btn btn-dark"><img src="/assets/img/attach_blue.svg"
                                                                          alt=""></button>
                                    </div>

                                    <i class="fa fa-plus float-left "
                                       style="font-size: 24px;cursor: pointer; margin-left: 14px; margin-top: 8px;"></i>


                                </div>
                            </div>


                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <button class="btn-dark float-right mt-5">Done</button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "documents",
    }
</script>

<style scoped>
    .search-box {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        border: 1px solid #292929;
        border-radius: 4px;
        height: 40px;
        width: 20rem;
    }

    .search-btn {
        background: transparent;
        border: unset;
        margin-left: -30px;

        -webkit-appearance: none;
    }
    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 900px;
            margin: 1.75rem auto;
            margin-top: 9rem;
        }

        .delete-modal {
            max-width: 600px !important;
            margin: 1.75rem auto;
        }
    }
    .flex-container {
        display: flex;
        flex-flow: row wrap;
        position: relative;
        width: auto;
        align-items: center;

        opacity: 1;
    }

    .flex-body {
        background: #4192D9 0% 0% no-repeat padding-box;
        box-shadow: 1px 5px 10px #0000004B;
        border-radius: 20px;
    }

    .item {
        flex: 1 1 18%;
        height: auto;
        margin: 4px;
        padding: 20px 0;
        width: auto;
    }
</style>
